import { AmountOffCouponBase } from '../amount-off/amount-off-base';
import { CategoryBaseTriggerItemsQualifier } from "../../coupon-qualifiers/trigger-items/category-base-trigger-items";
export class PercentOffAllItemsInCategoryCoupon extends AmountOffCouponBase {
    constructor(appType, sourceData, deps, baseData, identity) {
        super(appType, sourceData, deps, baseData, identity);
        this._preQualifiers.push(new CategoryBaseTriggerItemsQualifier(this._data, false));
    }
    getDiscountItems(cart) {
        return this._getDiscountItemsFromTriggers(cart);
    }
    /**
    * The percentage comes off the QUALIFIED CATEGORY ITEMS, not the order.
    * Matches legacy POS: `totalAmounts.OrderItemPrice * coupon.Discount / 100`
    * for Percentage_Off_All_Items_In_Category.
    */
    computeDiscountAmount(totalAmounts, cart) {
        const amt = totalAmounts.orderItemPrice * this._discountAmount / 100;
        return this._adjustDiscountAmount(cart, amt);
    }
}
//# sourceMappingURL=percent-off-all-items-in-category.js.map